// API Configuration for Orryworx Website
export const API_BASE_URL = "https://api.doclift.ai";

export const ENDPOINTS = {
  ALL_PUBLIC_TENANT_PROFILES: `${API_BASE_URL}/public/tenants/profiles`,
  PUBLIC_TENANTS: `${API_BASE_URL}/public/tenants`,
  PUBLIC_TENANT_PROFILE: (tenantId) => `${API_BASE_URL}/public/tenants/${tenantId}/profile`,
};
